import layoutHeaderAside from '@/layouts/HeaderAside'
const meta = { auth: true }
export default {
  path: '/commerce',
  meta,
  component: layoutHeaderAside,
  children: [
    {
      path: '/',
      name: 'commerce_index',
      component: () => import('@/pages/commerce/index.vue'),
      meta: {
        ...meta,
        title: '商贸交易'
      }
    },
    {
      path: '/commerce/customerCommunication',
      name: 'customerCommunication',
      component: () => import('@/pages/commerce/customerCommunication.vue'),
      meta: {
        ...meta,
        title: '客户交流',
      }
    },
    {
      path: '/commerce/listQuery',
      name: 'commerce_listQuery',
      component: () => import('@/pages/commerce/listQuery.vue'),
      meta: {
        ...meta,
        title: '挂单查询',
      }
    },
    {
      path: '/commerce/bidquiry',
      name: 'commerce_bidquiry',
      component: () => import('@/pages/commerce/bidquiry.vue'),
      meta: {
        ...meta,
        title: '竞价公告查询',
      }
    },
    {
      path: '/commerce/listPayable',
      name: 'listPayable',
      component: () => import('@/pages/commerce/commerce-listPayable/commerce-listPayable.vue'),
      meta: {
        ...meta,
        title: '挂单应单',
        requireAuth: true
      }
    },
    {
      path: '/commerce/listPayable/createListModfi',
      name: 'commerce_createListModfi',
      component: () => import('@/pages/commerce/commerce-listPayable/commerce-listPayable-createListModfi.vue'),
      meta: {
        ...meta,
        title: '挂单',
        requireAuth: true
      }
    },
    {
      path: '/commerce/listPayable/detailsInvoice',
      name: 'commerce_detailsListInvoice',
      component: () => import('@/pages/commerce/commerce-listPayable/commerce-listPayable-detailsInvoice.vue'),
      meta: {
        ...meta,
        title: '挂单详情',
        requireAuth: true
      }
    },
    {
      path: '/commerce/listPayable/AnswerList',
      name: 'commerce_myAnswerList',
      component: () => import('@/pages/commerce/commerce-listPayable/commerce-listPayable-AnswerList.vue'),
      meta: {
        ...meta,
        title: '应单',
        requireAuth: true
      }
    },
    {
      path: '/commerce/contracManagement',
      name: 'commerce_contract',
      component: () => import('@/pages/commerce/commerce-contracManagement/commerce-contracManagement.vue'),
      meta: {
        ...meta,
        title: '合同管理',
        requireAuth: true
      }
    },
    {
      path: '/commerce/contracManagement/contractConfirm',
      name: 'commerce_contractConfirm',
      component: () => import('@/pages/commerce/commerce-contracManagement/commerce-contracManagement-contractConfirm.vue'),
      meta: {
        ...meta,
        title: '合同确认',
        requireAuth: true
      }
    },
    {
      path: '/commerce/contracManagement/detilContract',
      name: 'commerce_detilContract',
      component: () => import('@/pages/commerce/commerce-contracManagement/commerce-contracManagement-DetilContract.vue'),
      meta: {
        ...meta,
        title: '合同详情',
        requireAuth: true
      }
    },
    {
      path: '/commerce/directionalTrading',
      name: 'directionalTrading',
      component: () => import('@/pages/commerce/commerce-directionalTrading/commerce-directionalTrading.vue'),
      meta: {
        ...meta,
        title: '定向交易',
        requireAuth: true
      }
    },
    {
      path: '/commerce/directionalTrading/newTransactionModifi',
      name: 'commerce_newTransactionModifi',
      component: () => import('@/pages/commerce/commerce-directionalTrading/commerce-directionalTrading-newTransactionModifi.vue'),
      meta: {
        ...meta,
        title: '定向交易',
        requireAuth: true
      }
    },
    {
      path: '/commerce/directionalTrading/transactionDetails',
      name: 'commerce_transactionDetails',
      component: () => import('@/pages/commerce/commerce-directionalTrading/commerce-directionalTrading-transactionDetails.vue'),
      meta: {
        ...meta,
        title: '定向交易详情',
        requireAuth: true
      }
    },
    {
      path: '/commerce/bidAuction',
      name: 'bidAuction',
      component: () => import('@/pages/commerce/commerce-bidAuction/commerce-bidAuction.vue'),
      meta: {
        ...meta,
        title: '竞买竞卖',
        requireAuth: true
      }
    },
    {
      path: '/commerce/bidAuction/newBidModifi',
      name: 'commerce_newBidModifi',
      component: () => import('@/pages/commerce/commerce-bidAuction/commerce-bidAuction-newBidModifi.vue'),
      meta: {
        ...meta,
        title: '竞买竞卖',
        requireAuth: true
      }
    },
    {
      path: '/commerce/bidAuction/biddingNotice',
      name: 'commerce_biddingNotice',
      component: () => import('@/pages/commerce/commerce-bidAuction/commerce-bidAuction-biddingNotice.vue'),
      meta: {
        ...meta,
        title: '竞价公告',
        requireAuth: true
      }
    },
    {
      path: '/commerce/bidAuction/participatingBidding',
      name: 'commerce_participatingBidding',
      component: () => import('@/pages/commerce/commerce-bidAuction/commerce-bidAuction-participatingBidding.vue'),
      meta: {
        ...meta,
        title: '参与竞价',
        requireAuth: true
      }
    }
  ]
}
